import Icon, { AppleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';

import AndroidSvg from '@/components/Icon/svgs/android.svg';
import ChromeSvg from '@/components/Icon/svgs/chrome.svg';
import CloseSvg from '@/components/Icon/svgs/close.svg';
import FirefoxSvg from '@/components/Icon/svgs/firefox.svg';
// import GiftSvg from '@/components/Icon/svgs/gift_bring.svg';
import QuestionSvg from '@/components/Icon/svgs/help_fill.svg';
import PhoneSvg from '@/components/Icon/svgs/phone_iphone.svg';
// import TestSvg from '@/components/Icon/svgs/test.svg';
import PAPopover from '@/components/popover';
import { LogoUrl } from '@/constants';
import useGeniusLayout from '@/hooks/useGeniusLayout';
// import { useModel } from '@/hooks/useModel';
import useStorage from '@/hooks/useStorage';
import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';
import { ROUTER_PATH } from '@/utils/router';

import { LayoutSecondaryPanelEnum, type TabItem, type ViewTabsEnum } from '../constants';
import MenuTab from './MenuTab';
import SystemMenu from './SystemMenu';
import styles from './index.less';

interface IProps {
  className?: string;
  tabList: TabItem[];
  hideTabs?: boolean;
  hideReturn?: boolean;
  onClickTab: (v: ViewTabsEnum) => void;
}

const ViewTabs = (props: IProps): JSX.Element => {
  const { className, tabList, hideTabs, onClickTab } = props;
  const [layoutSecondaryPanel, setLayoutSecondaryPanel] = useStorage('layoutSecondaryPanel');
  const [foldTabs, setFoldTabs] = useState<boolean>(false);
  const { type, tabKey: activeTab } = useGeniusLayout();
  // const { isLogin } = useModel('auth-model', (model) => ({ isLogin: model.isLogin }));
  const noTabs = type === 'log';
  const router = useRouter();
  const [isNew, setIsNew] = useState<boolean>(false);
  const [popupOpen, setPopupOpen] = useState(false);

  const widgetOpenRef = useRef<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { t } = useTranslation();

  const handleOpenChange = (open: boolean) => {
    if (isNew) {
      return;
    }

    setPopupOpen(open);
  };

  const closeExtensionPopup = () => {
    if (isNew) {
      // 让popup先关闭，避免还没关闭先变色
      setPopupOpen(false);
      setTimeout(() => {
        setIsNew(false);
        localStorage.setItem('hasShownExtensionNew', 'true');
      }, 300);
    }
  };

  // useEffect(() => {
  //   if (!finishedWelcomeReward) {
  //     setShowDot(true);
  //   }
  // }, [finishedWelcomeReward]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!localStorage.getItem('hasShownExtensionNew')) {
        setIsNew(true);
        setPopupOpen(true);
      }

      if (document.querySelector('#mebot-save-content')) {
        setPopupOpen(false);
        setIsNew(false);
      }
    }
  }, []);

  // useEffect(() => {
  //   if (finishedWelcomeReward !== undefined) {
  //     setShowReward(!finishedWelcomeReward);
  //   }
  // }, [finishedWelcomeReward]);

  // useEffect(() => {
  //   if (!isLogin) return;

  //   getWelcomeRewardDetail().then((res) => {
  //     if (res.data.code === 0) {
  //       updateWelcomeReward(res.data.data);
  //     }
  //   });
  // }, [isLogin]);

  useEffect(() => {
    const handleHideTabs = () => {
      setFoldTabs(true);
    };

    const handleShowTabs = () => {
      setFoldTabs(false);
    };

    addEventListener(EVENT.HIDE_VIEW_TABS, handleHideTabs);
    addEventListener(EVENT.SHOW_VIEW_TABS, handleShowTabs);

    return () => {
      removeEventListener(EVENT.HIDE_VIEW_TABS, handleHideTabs);
      removeEventListener(EVENT.SHOW_VIEW_TABS, handleShowTabs);
    };
  }, []);

  useEffect(() => {
    const showSubscription = () => {
      dispatchEvent(new Event(EVENT.FOLD_MENU));
      setLayoutSecondaryPanel(LayoutSecondaryPanelEnum.subscription);
    };

    addEventListener(EVENT.UNFOLD_SUBSCRIPTION, showSubscription);

    return () => {
      removeEventListener(EVENT.UNFOLD_SUBSCRIPTION, showSubscription);
    };
  }, []);

  useEffect(() => {
    const showApiKey = () => {
      dispatchEvent(new Event(EVENT.FOLD_MENU));
      setLayoutSecondaryPanel(LayoutSecondaryPanelEnum.apiKey);
    };

    addEventListener(EVENT.UNFOLD_API_KEY, showApiKey);

    return () => {
      removeEventListener(EVENT.UNFOLD_API_KEY, showApiKey);
    };
  }, []);

  useEffect(() => {
    setFoldTabs(!!hideTabs);
  }, [hideTabs]);

  // const handleReturnClick = useCallback<React.MouseEventHandler<HTMLSpanElement>>(
  //   (e) => {
  //     e.stopPropagation();

  //     const currentUrl = new URL(window.location.href);
  //     const returnPage = currentUrl.searchParams.get('returnPage');

  //     if (returnPage) {
  //       setLayoutSecondaryPanel(returnPage);
  //       currentUrl.searchParams.delete('returnPage');
  //       window.history.replaceState({}, '', currentUrl);

  //       return;
  //     }

  //     setLayoutSecondaryPanel('');
  //   },
  //   [setLayoutSecondaryPanel]
  // );

  const renderMenu = useCallback(() => {
    return (
      <div className={styles.menuContainer}>
        <div
          className={styles.menuItem}
          onClick={() => {
            handleOpenChange(false);
            layoutSecondaryPanel === 'iosPhone'
              ? setLayoutSecondaryPanel('')
              : setLayoutSecondaryPanel('iosPhone');
          }}
        >
          <AppleFilled className={styles.icon} />
          <span className={styles.text}>{t('leftTabs.iosApp')}</span>
        </div>
        <div
          className={styles.menuItem}
          onClick={() => {
            handleOpenChange(false);
            layoutSecondaryPanel === 'androidPhone'
              ? setLayoutSecondaryPanel('')
              : setLayoutSecondaryPanel('androidPhone');
          }}
        >
          <Icon className={styles.icon} component={AndroidSvg} />
          <span className={styles.text}>{t('leftTabs.androidApp')}</span>
        </div>
        <div
          className={classNames(styles.menuItem)}
          onClick={() => {
            setIsNew(false);
            localStorage.setItem('hasShownExtensionNew', 'true');
            window.open(
              'https://chromewebstore.google.com/detail/mebot/iplpjgbkmkccekbflkdiejihgjcelloa'
            );
          }}
        >
          <Icon className={styles.icon} component={ChromeSvg} />
          <span className={styles.text}>{t('leftTabs.chromeExtension')}</span>
        </div>
        <div
          className={classNames(styles.menuItem)}
          onClick={() => {
            setIsNew(false);
            localStorage.setItem('hasShownExtensionNew', 'true');
            window.open('https://addons.mozilla.org/en-US/firefox/addon/e093801438a444208dd1/');
          }}
        >
          <Icon className={styles.icon} component={FirefoxSvg} />
          <span className={styles.text}>{t('leftTabs.firefoxAddons')}</span>
          <div
            className={
              'w-[29px] h-[16px] bg-[#7B67EF] rounded-[24px] flex items-center justify-center ml-2'
            }
          >
            <span className="text-[12px] text-[#fefdff] scale-75 whitespace-nowrap">
              {t('leftTabs.beta')}
            </span>
          </div>
        </div>
      </div>
    );
  }, [layoutSecondaryPanel, setLayoutSecondaryPanel]);

  const renderExtension = () => {
    return (
      <div className={styles.extensionContainer}>
        <div className={styles.closeIcon} onClick={closeExtensionPopup}>
          <Icon component={CloseSvg} />
        </div>
        <div className={styles.description}>
          <div
            className={
              'w-fit h-[16px] rounded-[4px] flex flex-row justify-center items-center p-[2px_4px_2px_6px] gap-1.5 bg-[#7B67EF]'
            }
          >
            <span className="text-[12px] text-[#fefdff] scale-75">Recommended</span>
          </div>
          <div className="font-helvetica-neue text-sm font-medium leading-6 tracking-normal text-[#160A0A]">
            Browser extension
          </div>
          <div className="font-helvetica-neue text-xs font-normal leading-5 tracking-normal text-[#756C5D]">
            Use Web Clipper to instantly save anything with ease!
          </div>
        </div>
        <div
          className={classNames(styles.extensionItem)}
          onClick={() => {
            closeExtensionPopup();
            setTimeout(() => {
              window.open(
                'https://chromewebstore.google.com/detail/mebot/iplpjgbkmkccekbflkdiejihgjcelloa'
              );
            }, 310);
          }}
        >
          <img
            alt="chrome icon"
            className={styles.image}
            src="https://mindverseglobal.mindverse.com/front-img/%2Fpopupover/1735804794092/chrome.png"
          />
          <span className={styles.text}>Add to Chrome</span>
        </div>
        <div
          className={classNames(styles.extensionItem)}
          onClick={() => {
            closeExtensionPopup();
            setTimeout(() => {
              window.open('https://addons.mozilla.org/en-US/firefox/addon/e093801438a444208dd1/');
            }, 310);
          }}
        >
          <img
            alt="firefox icon"
            className={styles.image}
            src="https://mindverseglobal.mindverse.com/front-img/%2Fpopupover/1735804794092/firefox.png"
          />
          <span className={styles.text}>Add to Firefox</span>
        </div>
      </div>
    );
  };

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={styles.logoContainer}
        data-role="edit-ignore-blur"
        onClick={() => {
          router.push(ROUTER_PATH.personalAI);
          setLayoutSecondaryPanel('');
          dispatchEvent(new CustomEvent(EVENT.CLEAR_SEARCH_PARAMS, { detail: 'pahome' }));
        }}
      >
        <img className={styles.logo} src={LogoUrl} />
        <div className="text-primary-black text-sm leading-6 font-[Calistoga-Regular]">
          Second Me
        </div>
      </div>
      {/* <AutoHide
        className={styles.iconContainer}
        classNoChild="h-0 hidden"
        id={EGlobalId.RETURN_ICON_CONTAINER}
      >
        {isLogin &&
          (layoutSecondaryPanel && !hideReturn ? (
            <Icon className={styles.returnIcon} component={ReturnSVG} onClick={handleReturnClick} />
          ) : // <ReturnIcon activeTab={activeTab} type={type} />
          null)}
      </AutoHide> */}
      {!noTabs && (
        <div className={classNames(styles.tabContainer, { [styles.fold]: foldTabs })}>
          <div className={styles.tabList}>
            {tabList.map((item: TabItem) => (
              <MenuTab
                key={item.key}
                activeTab={activeTab as string}
                item={item}
                onClickTab={(tab: ViewTabsEnum) => onClickTab(tab)}
              />
            ))}
          </div>
          <div className={styles.menuList}>
            {/* {showAgent ? (
              <Icon
                className={styles.menuItem}
                component={TestSvg}
                onClick={() => {
                  router.push(ROUTER_PATH.talks);
                }}
              />
            ) : null} */}

            <Button
              ref={buttonRef}
              className={classNames(
                styles.menuItem,
                'border-none shadow-none flex items-center justify-center'
              )}
              data-featurebase-feedback-portal
              onClick={() => {
                if (!widgetOpenRef.current) {
                  widgetOpenRef.current = true;
                  // 添加一个全屏的遮罩，点击遮罩的时候关闭
                  const mask = document.createElement('div');

                  mask.style.position = 'fixed';
                  mask.style.top = '0';
                  mask.style.left = '0';
                  mask.style.width = '100%';
                  mask.style.height = '100%';
                  mask.style.backgroundColor = 'rgba(0, 0, 0, 0.01)';
                  mask.style.zIndex = '9999';
                  document.body.appendChild(mask);
                  mask.addEventListener('click', () => {
                    buttonRef.current?.click();
                    mask.remove();
                  });
                } else {
                  widgetOpenRef.current = false;
                }
              }}
            >
              <Icon component={QuestionSvg} />
            </Button>

            <PAPopover
              content={isNew ? renderExtension() : renderMenu()}
              onOpenChange={handleOpenChange}
              open={popupOpen}
              overlayClassName={styles.overlayWhiteClassName}
              placement="right"
              trigger={'click'}
            >
              <div className="relative" onClick={closeExtensionPopup}>
                <Icon className={styles.menuItem} component={PhoneSvg} />
                <div
                  className={
                    'w-[27px] h-[16px] bg-[#7B67EF] rounded-[24px] flex items-center justify-center ml-2 absolute top-[-5px] right-[-10px]'
                  }
                  style={{ display: isNew ? 'flex' : 'none' }}
                >
                  <span className="text-[12px] text-[#fefdff] scale-75">New</span>
                </div>
              </div>
            </PAPopover>

            <SystemMenu />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewTabs;
